export default __webpack_public_path__ + "static/media/ic_gray_down_arrow.e5816149.svg";